<div
	class="d-flex align-items-center justify-content-center w-100"
	[class.flex-row-reverse]="alignment === ChartAlignment.Left"
	[class.justify-content-end]="alignment === ChartAlignment.Left"
	[class.h-100]="this.isInH100Mode">
	<div>
		<div class="d-flex flex-column pe-2">
			<div class="d-flex justify-content-end">
				<div class="grid-container align-items-center">
					@for (item of data; track item) {
						<div class="border colorbox mx-2" [style.background-color]="item.color"></div>
						<div class="pe-3 no-line-break">
							{{ item.category }}
						</div>
						@if (!showPercentage) {
							<div class="text-end fw-bold">
								{{ item.value | numberFormat }}
							</div>
						}
						@if (showPercentage) {
							<div [ngbTooltip]="getLabelTooltip(item.percentage)" class="text-end fw-bold">
								{{ itemText(item) }}
							</div>
						}
					}
				</div>
			</div>
		</div>
	</div>
	<div [class.h-100]="this.isInH100Mode">
		@if (data?.length && dataSum !== 0) {
			<kendo-chart
				[ngClass]="classes"
				[tooltip]="tooltip"
				[style]="{ height: diameter, width: diameter }"
				[class.h-100]="this.isInH100Mode">
				<kendo-chart-title [text]="title ? title : ''" [font]="'1.25rem Roboto, sans-serif'"> </kendo-chart-title>
				<kendo-chart-series>
					<kendo-chart-series-item
						type="pie"
						[autoFit]="true"
						color="color"
						[data]="data"
						categoryField="category"
						field="percentage">
					</kendo-chart-series-item>
				</kendo-chart-series>
				<kendo-chart-tooltip>
					<ng-template kendoChartSeriesTooltipTemplate let-dataItem="dataItem">
						<div class="d-flex justify-content-center flex-column">
							<span class="fw-bold">{{ dataItem.category }}</span>
							<span>{{ itemText(dataItem) }}</span>
						</div>
					</ng-template>
				</kendo-chart-tooltip>
				<kendo-chart-legend [visible]="false"> </kendo-chart-legend>
			</kendo-chart>
		} @else {
			<app-chart-placeholder-percentage
				[isInH100Mode]="this.isInH100Mode"
				type="pie"
				[title]="title ? title : ''"
				[height]="diameter"
				[classes]="classes">
			</app-chart-placeholder-percentage>
		}
	</div>
</div>
